import React, { useEffect } from 'react'
import { Button, Spin, Modal, Form, Input, message } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { clearState, createProjectAction, projectSelector } from '../../../store/projects'

const messageProjectKey = 'add_new_project'

const AddProjectModal = ({ showModal, onChancel, onFinish }) => {
  const dispatch = useDispatch()
  const { isAddSuccess, isFetching } = useSelector(projectSelector)
  const [form] = Form.useForm()

  const onChancelClick = () => {
    onChancel()
    form.resetFields()
  }

  const onFinishCallback = ({ name, description }) => {
    dispatch(
      createProjectAction({
        name,
        description,
      })
    )
  }

  useEffect(() => {
    if (showModal && !isFetching && isAddSuccess) {
      message.success({ content: 'Проект добавлен успешно', key: messageProjectKey })
      onFinish()
      form.resetFields()
      dispatch(clearState())
    }
  }, [isFetching, isAddSuccess, showModal, dispatch, onFinish, form])

  return (
    <Modal
      title="Новый проект"
      visible={showModal}
      onCancel={onChancelClick}
      footer={[
        <Button key="back" onClick={onChancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Добавить
        </Button>,
      ]}
    >
      <Spin spinning={isFetching}>
        <Form
          name="new-project"
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
          onFinish={onFinishCallback}
          // onFinishFailed={onFinishFailed}
          form={form}
          size="large"
        >
          <Form.Item label="Название проекта" name="name" rules={[{ required: true, message: 'Поле обязательно' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Описание" name="description">
            <Input />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default AddProjectModal
